module.exports = __webpack_public_path__ + "img/chevron-down-nb.fdfd9e69.svg";